import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/global/seo"
import HeroImage from "../components/global/heroImage"
import Introduction from "../components/home/intro"
import Schedule from "../components/home/schedule"
import TreatmentsTeaser from "../components/home/treatmentsTeaser"

const IndexPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO title="Home" />
      <Layout>
        <HeroImage
          img={data.heroImage.featured_media.localFile.childImageSharp.fluid}
          openingText={data.heroImage.acf.front_image_text.text}
          styleClass="hero-image"
          altText={data.heroImage.featured_media.alt_text}
        />
        <Introduction />
        <Schedule data={data.schedule.edges} image={data.scheduleImage} />
        <TreatmentsTeaser data={data.treatments.edges} />
      </Layout>
    </React.Fragment>
  )
}

export default IndexPage

export const query = graphql`
  {
    site {
      siteMetadata {
        menuLinks {
          name
          link
          id
        }
      }
    }
    heroImage: wordpressPage(slug: { eq: "home" }) {
      acf {
        front_image_text {
          text
        }
      }
      featured_media {
        localFile {
          childImageSharp {
            fluid(quality: 100, maxWidth: 2000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    schedule: allWordpressWpClinicSchedule(sort: { fields: date, order: ASC }) {
      edges {
        node {
          title
          id
          acf {
            is_clinic_opened
            open_at
            close_at
          }
        }
      }
    }
    scheduleImage: wordpressPage(slug: { eq: "home" }) {
      acf {
        photo_featurette {
          alt_text
          localFile {
            childImageSharp {
              fluid(quality: 100, maxWidth: 2000) {
                src
              }
            }
          }
        }
      }
    }
    treatments: allWordpressWpTreatments(
      filter: { acf: { is_featured: { eq: true } } }
    ) {
      edges {
        node {
          id
          title
          content
          slug
          featured_media {
            alt_text
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 2000) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
